const DEFAULT_TRUE_LABEL = 'Oui';
const DEFAULT_FALSE_LABEL = 'Non';

export function formatBoolean(
  boolean: boolean,
  {
    trueLabel = DEFAULT_TRUE_LABEL,
    falseLabel = DEFAULT_FALSE_LABEL,
  }: { trueLabel?: string; falseLabel?: string } = {
    trueLabel: DEFAULT_TRUE_LABEL,
    falseLabel: DEFAULT_FALSE_LABEL,
  },
): string {
  return boolean ? trueLabel : falseLabel;
}
